import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type InsightsQuery from "./InsightsQuery";

@Model()
class InsightsQueryFilter extends ApplicationRecord {
  static jsonapiType = "insights_query_filters";

  @Attr() action: string;

  @BelongsTo() insightsQuery: InsightsQuery;

  @Attr() objectId: number;

  @Attr() objectType: string;

  @Attr() scope: string;

  @Attr() targetId: number;

  @Attr() targetType: string;
}

export default InsightsQueryFilter;
